<div class="layout-content">
  <app-left-panel class="left-panel"></app-left-panel>
  <app-center-panel class="center-panel"></app-center-panel>
</div>